const toggle = document.querySelector(".drawer-toggle");
const overlay = document.querySelector(".site-drawer-overlay");
const drawer = document.querySelector(".site-drawer");
const drawerMenuLinkEls = document.querySelectorAll(".site-drawer a");

function getScrollbarWidth() {
  return window.innerWidth - document.documentElement.clientWidth;
}

function setDrawer(open) {
  const scrollbarWidth = getScrollbarWidth();

  document.body.classList.toggle("drawer-open", open);
  document.body.style.paddingRight = open ? scrollbarWidth + "px" : "";
  document.querySelector(".header").style.paddingRight = open
    ? scrollbarWidth + "px"
    : "";

  toggle.setAttribute("aria-expanded", open ? "true" : "false");
  drawer.setAttribute("aria-hidden", open ? "false" : "true");
  window.scrollTo(0, 0);
}

toggle.addEventListener("click", () => {
  const isOpen = document.body.classList.contains("drawer-open");
  setDrawer(!isOpen);
});

overlay.addEventListener("click", () => setDrawer(false));
drawerMenuLinkEls.forEach(function (drawerMenuLinkEl) {
  drawerMenuLinkEl.addEventListener("click", () => setDrawer(false));
});

document.addEventListener("keydown", (e) => {
  if (e.key === "Escape") setDrawer(false);
});

(function () {
  const navItems = document.querySelectorAll(
    ".site-drawer__nav-item--have-child",
  );

  navItems.forEach(function (navItem) {
    const topToggle = Array.from(navItem.children).find(function (child) {
      return (
        child.classList &&
        child.classList.contains("site-drawer__accordion-toggle")
      );
    });

    if (!topToggle) return;

    topToggle.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();

      const isOpen = navItem.classList.contains("is-open");

      navItems.forEach(function (otherNavItem) {
        otherNavItem.classList.remove("is-open");

        const otherTopToggle = Array.from(otherNavItem.children).find(
          function (child) {
            return (
              child.classList &&
              child.classList.contains("site-drawer__accordion-toggle")
            );
          },
        );

        if (otherTopToggle) {
          otherTopToggle.setAttribute("aria-expanded", "false");
        }

        otherNavItem
          .querySelectorAll(".site-drawer__accordion-item")
          .forEach(function (subItem) {
            subItem.classList.remove("is-open");

            const subToggle = Array.from(subItem.children).find(
              function (child) {
                return (
                  child.classList &&
                  child.classList.contains("site-drawer__accordion-toggle")
                );
              },
            );

            if (subToggle) {
              subToggle.setAttribute("aria-expanded", "false");
            }
          });
      });

      if (!isOpen) {
        navItem.classList.add("is-open");
        topToggle.setAttribute("aria-expanded", "true");
      }
    });

    const subItems = navItem.querySelectorAll(".site-drawer__accordion-item");

    subItems.forEach(function (subItem) {
      const subToggle = Array.from(subItem.children).find(function (child) {
        return (
          child.classList &&
          child.classList.contains("site-drawer__accordion-toggle")
        );
      });

      if (!subToggle) return;

      subToggle.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();

        const isOpen = subItem.classList.contains("is-open");

        subItems.forEach(function (otherSubItem) {
          otherSubItem.classList.remove("is-open");

          const otherSubToggle = Array.from(otherSubItem.children).find(
            function (child) {
              return (
                child.classList &&
                child.classList.contains("site-drawer__accordion-toggle")
              );
            },
          );

          if (otherSubToggle) {
            otherSubToggle.setAttribute("aria-expanded", "false");
          }
        });

        if (!isOpen) {
          subItem.classList.add("is-open");
          subToggle.setAttribute("aria-expanded", "true");
        }
      });
    });
  });

  const navMenu = document.querySelector(".nav-menu");
  if (!navMenu) return;
  const drawerMenu = navMenu.cloneNode(true);
  drawerMenu.innerHTML = drawerMenu.innerHTML.replaceAll(
    "nav-menu",
    "drawer-menu",
  );
  drawerMenu.classList.remove("nav-menu");
  drawerMenu.classList.add("drawer-menu");
  drawer.appendChild(drawerMenu);
})();

document
  .querySelectorAll(".drawer-menu__item--has-children > .drawer-menu__link")
  .forEach((link) => {
    link.addEventListener("click", function (e) {
      e.preventDefault();

      const parent = this.parentElement;
      const dropdown = parent.querySelector(".drawer-menu__dropdown");
      const isOpen = parent.classList.contains("is-open");

      const activeItems = parent.parentElement.querySelectorAll(
        ".drawer-menu__item--has-children.is-open",
      );
      activeItems.forEach((item) => {
        if (item !== parent) {
          item.classList.remove("is-open");
          item
            .querySelector(".drawer-menu__dropdown")
            .style.setProperty("--menu-height", "0px");
        }
      });

      if (!isOpen) {
        const height = dropdown.scrollHeight;
        dropdown.style.setProperty("--menu-height", height + "px");
        parent.classList.add("is-open");
      } else {
        dropdown.style.setProperty("--menu-height", "0px");
        parent.classList.remove("is-open");
      }
    });
  });
